import { useTranslation } from "react-i18next";
import { useExchangeRateQuery } from "../api/queries/exchangeRateQueries";

const formatMoney = (
  amount?: number | null,
  currency: string = "USD",
  locale: string = "en-US",
): string => {
  if (amount === undefined || amount === null) {
    return "";
  }
  if (amount < 0) {
    amount = -amount;
    return "-" + handle(amount, currency, locale);
  }
  return handle(amount, currency, locale);
};

const handle = (
  amount: number,
  currency: string = "USD",
  locale: string = "en-US",
) => {
  try {
    const currencySymbols: { [key: string]: string } = {
      USD: "$",
      KRW: "₩",
      JPY: "¥",
      CNY: "¥",
      EUR: "€",
    };

    const symbol = currencySymbols[currency] || currency;
    const formattedAmount = amount
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    let result = `${symbol}${formattedAmount}`;
    if (locale === "en-US") {
      result = `${symbol}${formattedAmount}`;
    } else if (locale === "es") {
      result = `${formattedAmount} ${symbol}`;
    }

    if (result.endsWith(".00")) {
      return result.substring(0, result.length - 3);
    }
    return result;
  } catch (error) {
    console.error("Error formatting money:", error);
    return amount.toString(); // Fallback to string representation of the number
  }
};
export const useMoney = () => {
  // const { i18n } = useTranslation();
  // const locale = i18n.language;
  // const { data: rateData, isLoading, error } = useExchangeRateQuery();
  // let rate = 1;

  // //base on locale, get the currency: ko, us, jp, cn, es
  // let currency = "USD";
  // if (locale === "ko") {
  //   currency = "KRW";
  // } else if (locale === "jp") {
  //   currency = "JPY";
  // } else if (locale === "cn") {
  //   currency = "CNY";
  // } else if (locale === "es") {
  //   currency = "EUR";
  // }

  // if (isLoading || error) {
  //   return {
  //     formatMoney: (amount?: number | null) => formatMoney(amount, "USD", "us"),
  //   };
  // }

  // if (rateData) {
  //   // Find the rate for the currency base currency
  //   const rateExchange = rateData.find(
  //     (rate: any) => rate.targetCurrency === currency,
  //   )?.rate;
  //   if (rateExchange) {
  //     rate = rateExchange;
  //   }
  // }

  // return {
  //   formatMoney: (
  //     amount?: number | null
  //   ) => formatMoney(amount ? amount * rate : amount, currency, locale)
  // };

  return {
    formatMoney: (amount?: number | null) => formatMoney(amount, "USD", "us"),
  };
};
